import React, { useState, useMemo, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { TagSelect } from '../../../components/TagSelect';

export function KeySkills({ habilidades = [], onUpdate }) {
   const [modalOpen, setModalOpen] = useState(false);
   const [selectedTags, setSelectedTags] = useState([]);

   // Convertir habilidades a array de objetos para TagSelect
   const initialTags = useMemo(() => {
      if (!habilidades) return [];

      if (Array.isArray(habilidades)) {
         return habilidades.map(habilidad => {
            // Si la habilidad ya viene como string
            if (typeof habilidad === 'string') {
               return {
                  id: habilidad,
                  nombre: habilidad,
                  label: habilidad,
                  value: habilidad,
               };
            }

            // Si la habilidad viene con la estructura { tag: { id, nombre } }
            if (habilidad && habilidad.tag && habilidad.tag.nombre) {
               return {
                  id: habilidad.tag.id || habilidad.tag.nombre,
                  nombre: habilidad.tag.nombre,
                  label: habilidad.tag.nombre,
                  value: habilidad.tag.nombre,
               };
            }

            // Si la habilidad viene como objeto plano { id, nombre } u otras variantes
            const nombre = habilidad && (habilidad.nombre || habilidad.label || habilidad.value) || '';
            const id = habilidad && (habilidad.id || habilidad.value || nombre) || nombre;
            return {
               id,
               nombre,
               label: nombre,
               value: nombre,
            };
         });
      }

      return [];
   }, [habilidades]);

   // Actualizar el estado local cuando cambia la prop o se abre el modal
   useEffect(() => {
      if (modalOpen) {
         setSelectedTags(initialTags);
      }
   }, [initialTags, modalOpen]);

   const handleSave = () => {
      if (onUpdate) {
         // Convertir array de tags a array de strings (nombres)
         // El backend/endpoint espera recibir un arreglo de strings.
         const habilidadesArray = selectedTags
            .map(tag => tag.nombre || tag.label || tag.value || '')
            .map(s => (typeof s === 'string' ? s.trim() : ''))
            .filter(s => s.length > 0);

         onUpdate(habilidadesArray);
      }
      setModalOpen(false);
   };

   const handleTagsChange = (tags) => {
      setSelectedTags(tags);
   };

   // Convertir habilidades a array de strings para mostrar
   // Usar las habilidades guardadas (de la prop) para mostrar, no las del estado local
   const habilidadesArray = useMemo(() => {
      if (!habilidades) return [];

      // Si es un array de objetos
      if (Array.isArray(habilidades)) {
         return habilidades.map(h => {
            if (typeof h === 'string') return h;
            // Si tiene la estructura del backend con tag anidado
            if (h.tag && h.tag.nombre) return h.tag.nombre;
            return h.nombre || h.label || h.value || '';
         }).filter(n => n.length > 0);
      }

      return [];
   }, [habilidades]);

   return (
      <div id="key_skills_bx" className="job-bx bg-white m-b30">
         <div className="d-flex">
            <h5 className="m-b15">Habilidades Clave</h5>
            <Link to={"#"} data-toggle="modal" data-target="#keyskills" onClick={() => setModalOpen(true)} className="site-button add-btn button-sm"><i className="fa fa-pencil m-r5"></i> Editar</Link>
         </div>
         {habilidadesArray.length > 0 ? (
            <div className="job-time mr-auto">
               {habilidadesArray.map((skill, index) => (
                  <Link key={index} to={"#"} className="mr-1"><span>{skill}</span></Link>
               ))}
            </div>
         ) : (
            <p className="m-b0">No has agregado habilidades aún. Haz clic en Editar para agregar algunas.</p>
         )}

         <Modal show={modalOpen} onHide={() => {
            setModalOpen(false);
            // Resetear a los valores originales al cancelar
            setSelectedTags(initialTags);
         }} className="modal fade modal-bx-info editor">
            <div className="modal-dialog my-0" role="document" style={{ maxHeight: '90vh', margin: '30px auto' }}>
               <div className="modal-content" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                  <div className="modal-header" style={{ flexShrink: 0 }}>
                     <h5 className="modal-title" id="KeyskillsModalLongTitle">Habilidades Clave</h5>
                     <button type="button" className="close" onClick={() => setModalOpen(false)}>
                        <span aria-hidden="true">&times;</span>
                     </button>
                  </div>
                  <div className="modal-body" style={{ overflowY: 'auto', flex: '1 1 auto', minHeight: 0 }}>
                     <p>Las habilidades clave son tags identificatorios que puedes utilizar para llamar la atención de los reclutadores. Puedes buscar habilidades existentes o crear nuevas escribiendo y presionando Enter.</p>
                     <form>
                        <div className="row">
                           <div className="col-lg-12 col-md-12">
                              <div className="form-group">
                                 <label>Habilidades:</label>
                                 <TagSelect
                                    value={selectedTags}
                                    onChange={handleTagsChange}
                                    tipo="resume"
                                    placeholder="Selecciona o crea habilidades..."
                                 />
                              </div>
                           </div>
                        </div>
                     </form>
                  </div>
                  <div className="modal-footer" style={{ flexShrink: 0 }}>
                     <button type="button" className="site-button" onClick={() => {
                        setModalOpen(false);
                        // Resetear a los valores originales al cancelar
                        setSelectedTags(initialTags);
                     }}>Cancelar</button>
                     <button type="button" className="site-button" onClick={handleSave}>Guardar</button>
                  </div>
               </div>
            </div>
         </Modal>

      </div>
   )
}
